import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useIAPList } from '@/modules/iap/model/list';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { questService } from '@/services/quest';
import { useVuelidate } from '@vuelidate/core';
import { integer, maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useQuestBoostEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { iapOptions, fetchIapOptions } = useIAPList();

    const model = reactive({
        id: route.params.boostId,
        packageId: '',
        price: 0,
        ratio: 0,
        timeUnit: 0,
        timeDuration: 0
    });

    const validations = {
        packageId: { required },
        price: { required, numeric, min: minValue(1) },
        ratio: { required, integer, min: minValue(1) },
        timeDuration: { required, integer, min: minValue(1), max: maxValue(32000) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => questService.boost.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_QUEST.BOOST.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                questService.boost.update(
                    model.id,
                    model.packageId,
                    model.price,
                    model.ratio,
                    model.timeUnit,
                    model.timeDuration
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.BOOST.INDEX })
        }),
        selectIAP: (iapId: any) => {
            iapOptions.value.forEach(item => {
                if (item.value == iapId) {
                    model.packageId = item.data.packageId;
                    model.price = item.data.price;
                    v$.value.$touch();
                }
            });
        }
    };

    onMounted(async () => {
        await fetchIapOptions();
        await fetch();
    });

    return { model, v$, actions, iapOptions };
}
